import { render, staticRenderFns } from "./GroupingSetting.vue?vue&type=template&id=6418da8e&scoped=true"
import script from "./GroupingSetting.vue?vue&type=script&lang=js"
export * from "./GroupingSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418da8e",
  null
  
)

export default component.exports